import { useStore } from 'react-redux';
import apiRequest from 'services/api/api.config';
import { makeSelectAuthApiConfig } from 'services/api/api.selectors';
import { getGameContractEndpoint } from 'services/user/user.config';
import { downloadFile } from 'utils/functions/downloadPDF';
import { useIsApp } from 'utils/hooks/useGetIsApp';

export function useDownloadContract() {
  const isApp = useIsApp();
  const reduxStore = useStore();
  const reduxState = reduxStore.getState();

  const downloadContractApp = async () => {
    const pdfUrl = 'https://appmobile.sisal.it/?appFunc=downloadContract';
    window.location.href = pdfUrl;
  };

  const downloadContractDesktop = async () => {
    const requestConfig = makeSelectAuthApiConfig({
      method: 'GET',
      url: getGameContractEndpoint,
      responseType: 'blob',
    })(reduxState);

    const response = await apiRequest.request(requestConfig);

    const fileName =
      response.headers['content-disposition'].split('filename=')[1];

    return downloadFile(response.data, fileName);
  };

  return isApp ? downloadContractApp : downloadContractDesktop;
}
